import { StepLogger } from "analytics/funnel";
import { History } from "history";
import L10n from "localization";
import GenFlashcardsNav from "./genFlashcardsNav";
import { OnboardingGoalInfo } from "./onboardingModal";
import SingleSelectNav, { IPromptOption } from "./singleSelectNav";

interface IProps {
  dismiss: () => Promise<void>;
  onAddToInbox: () => void;
  history: History;
  logStep: StepLogger;
  test: string;
}
export default function GoalTestVectorNav(props: IProps) {
  const opts: IPromptOption[] = [
    { name: L10n.localize((s) => s.general.none), val: "none" },
    { name: L10n.localize((s) => s.onboarding.testPrepDurationLessThan1Week), val: "<1 week" },
    {
      name: L10n.localize((s) => s.onboarding.testPrepDuration1WeekTo1Month),
      val: "1 week to 1 month",
    },
    { name: L10n.localize((s) => s.onboarding.testPrepDuration1To3Months), val: "1-3 months" },
    { name: L10n.localize((s) => s.onboarding.testPrepDuration3To6Months), val: "3-6 months" },
    { name: L10n.localize((s) => s.onboarding.testPrepDurationMoreThan6Months), val: "> 6 months" },
  ];
  return (
    <SingleSelectNav
      title={props.test}
      description={L10n.localize((s) => s.onboarding.testPrepDescription)}
      options={opts}
      dismiss={props.dismiss}
      history={props.history}
      onNav={(prepOpt) => {
        const goal: OnboardingGoalInfo = {
          goal: "test",
          test: props.test,
          prepDuration: prepOpt.val,
        };
        const prompt = `Context: user is studying for a standardized test and wants flash cards of test questions to practice.
Test: ${goal.test}.
Preparation so far: ${goal.prepDuration}.
`;
        return (
          <GenFlashcardsNav
            prompt={prompt}
            dismiss={props.dismiss}
            history={props.history}
            onAddToInbox={props.onAddToInbox}
            logStep={props.logStep}
            goal={goal}
          />
        );
      }}
    />
  );
}
